package com.example.mystybag.common.model

import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.core.expected.sharedString

data class TextInputBSVisualModel(
    val initialText     : String                                    = "",
    val title           : String                                    = "",
    val hint            : String                                    = "",
    val errorText       : String                                    = "",
    val inputType       : TextFieldType?                            = null,
    val imageResource   : ImageResource?                            = null,
    val buttonText      : String                                    = sharedString(SR.strings.save),
    val capitalization  : KeyboardCapitalization                    = KeyboardCapitalization.Unspecified,
    val keyboardType    : KeyboardType                              = KeyboardType.Unspecified,
    val autoCorrect     : Boolean?                                  = null,
    val prefix          : String?                                   = null,
    val suffix          : String?                                   = null,
    /** Optional info prompt shown below the input (e.g. yellow alert for change email). */
    val infoPromptText  : String?                                   = null,
    val validate        : ((String) -> Pair<Boolean, String?>)?     = null,
    val onIconClick     : (() -> Unit)?                             = null,
    val onTextChanged   : (String) -> Unit                          = {}
)